import Ogaboss from '../../../public/ogaboss.svg'

const AuthBrand = () => {
    return (
        <div className="flex gap-2">
            <img alt="Ogaboss Icon" src={Ogaboss} />
            <span className="text-sm font-semibold text-[#17A2B8] italic pt-4">
                Admin
            </span>
        </div>
    )
}

export default AuthBrand
